import React from "react";
import { Box, Typography } from "@mui/material";
import { DASH } from "../../pages/Dashboard/dashboardTheme";

/** Tooltip estándar para gráficas recharts. */
export default function ChartTooltip({ active, payload, label, valueLabel = "" }) {
  if (!active || !payload?.length) return null;
  const item = payload[0]?.payload ?? payload[0];
  const displayLabel = label ?? item?.label ?? item?.name ?? item?.type;
  const value = payload[0]?.value ?? item?.count ?? item?.value ?? item?.total;

  return (
    <Box
      sx={{
        bgcolor: "#fff",
        border: `1px solid ${DASH.border}`,
        borderRadius: "10px",
        px: 1.75,
        py: 1.25,
        boxShadow: "0 8px 24px rgba(17,17,16,0.08)",
      }}
    >
      <Typography sx={{ fontSize: "11px", fontWeight: 500, color: DASH.textMuted }}>
        {displayLabel}
      </Typography>
      <Typography
        sx={{
          fontSize: "15px",
          fontFamily: DASH.fontMono,
          color: DASH.text,
          mt: 0.25,
          fontWeight: 500,
        }}
      >
        {value?.toLocaleString?.("es-MX") ?? value}
        {valueLabel && (
          <Typography component="span" sx={{ fontSize: "11px", color: DASH.textMuted, ml: 0.5 }}>
            {valueLabel}
          </Typography>
        )}
      </Typography>
    </Box>
  );
}
